module.exports = __webpack_public_path__ + "static/media/49.5cc13952.jpg";